import { observer } from 'mobx-react-lite';
import { useVideoQualityByParticipantCount } from 'hooks/useVideoQualityByParticipantCount';
import { STAGE_LAYOUT } from '../../../consts';
import { StageProps } from '../types';
import { StageFooter } from '../components/StageFooter';
import { useSort } from '../hooks/useSort';
import { GridParticipants } from './GridParticipants';
import { StageContainer } from './view';

export const GridStage = observer(({ roomState, controlRenderer, onLeave, hasRecorder }: StageProps) => {
    const { getSortedParticipants } = useSort();
    const participants = getSortedParticipants();

    // Grid Mode: качество только по количеству участников
    // все участники равны если нет спикера/фокуса
    useVideoQualityByParticipantCount({ stageLayout: STAGE_LAYOUT.GRID });

    return (
        <StageContainer $hasFooter={!hasRecorder}>
            <GridParticipants participants={participants} room={roomState.room} />
            {!hasRecorder && (
                <StageFooter
                    roomState={roomState}
                    controlRenderer={controlRenderer}
                    onLeave={onLeave}
                    participants={participants}
                />
            )}
        </StageContainer>
    );
});

GridStage.displayName = 'GridStage';
